
























































































































































































import Vue from 'vue';
import * as utenteApi from '../services/utente-api';
import { LoginViewModel, LoginViewType } from '../types';
import { mapActions } from 'vuex';
import validationRulesMixin from '../components/mixin/validation-rules-mixin';

export default Vue.extend({
    mixins: [validationRulesMixin],
    data(): LoginViewModel {
        return {
            isValid: false,
            username: null,
            password: null,
            viewType: LoginViewType.login,
            oldPassword: null,
            newPassword: null,
            passwordConfirmation: null,
        };
    },
    computed: {
        isLoginViewType(): boolean {
            return this.viewType == LoginViewType.login;
        },
        isPasswordScadutaViewType(): boolean {
            return this.viewType == LoginViewType.passwordScaduta;
        },
        isRecuperaPasswordViewType(): boolean {
            return this.viewType == LoginViewType.recuperaPassword;
        }
    },
    methods: {
        ...mapActions(['setUser']),
        async login() {
            const utente = await utenteApi.login({
                username: this.username ?? '',
                password: this.password ?? '',
            });
            if (utente.passwordScaduta) {
                this.setPasswordScadutaViewType();
                return;
            }
            this.setUser(utente);
            this.$router.push('/');
        },
        async changePassword() {
            await utenteApi.changePassword({
                username: this.username ?? '',
                oldPassword: this.oldPassword ?? '',
                newPassword: this.newPassword ?? '',
                passwordConfirmation: this.passwordConfirmation ?? '',
            });
            this.setLoginViewType();
        },
        async recuperaPassword() {
            await utenteApi.resetPassword({
                username: this.username ?? '',
            });
            this.setLoginViewType();
        },
        setLoginViewType() {
            this.viewType = LoginViewType.login;
        },
        setPasswordScadutaViewType() {
            this.viewType = LoginViewType.passwordScaduta;
        },
        setRecuperaPasswordViewType() {
            this.viewType = LoginViewType.recuperaPassword;
        }
    },
    mounted() {
        this.isValid = (this.$refs.form as HTMLFormElement).validate();
        (this.$refs.username as HTMLElement).focus();
    },
});
